module.exports = __webpack_public_path__ + "static/media/sd_call.2cd057e.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/attach/sd_call.mp3
// module id = soNF
// module chunks = 36